import React from "react";
import { Modal } from "antd";
import "./AddDrink.css";
import { SignInRequired } from "../../auth/signIn";
import { AddDrinkContent } from "./addDrink/AddDrinkContent";
import { useAddDrink } from "./addDrink/useAddDrink";

type AddDrinkProps = { embedded?: boolean; onRequestClose?: () => void };

const AddDrink: React.FC<AddDrinkProps> = (props) => {
    const state = useAddDrink(props);
    const { embedded, isAuthenticated, user, t, mobileModalVisible, handleCloseModal } = state;
    const addDrinkContent = <AddDrinkContent state={state} />;

    if (!isAuthenticated || !user) {
        const loginWarning = (
            <SignInRequired
                title={t("addDrink.loginRequiredTitle")}
                description={t("addDrink.loginRequiredDescription")}
            />
        );
        if (embedded) {
            return loginWarning;
        }
        return (
            <Modal
                className="add-drink-modal"
                title={<span className="ui-sr-only">{t("addDrink.title")}</span>}
                open={mobileModalVisible}
                footer={null}
                onCancel={handleCloseModal}
                destroyOnHidden
                styles={{ body: { padding: 16 } }}
                width="calc(100vw - 32px)"
                style={{ top: 32 }}
            >
                {loginWarning}
            </Modal>
        );
    }

    if (embedded) {
        return <div style={{ width: "100%" }}>{addDrinkContent}</div>;
    }

    return (
        <Modal
            className="add-drink-modal"
            title={<span className="ui-sr-only">{t("addDrink.title")}</span>}
            open={mobileModalVisible}
            footer={null}
            onCancel={handleCloseModal}
            destroyOnHidden
            maskClosable
            closable={false}
            styles={{
                body: {
                    maxHeight: "92dvh",
                    height: "92dvh",
                    padding: 0,
                },
            }}
            width="100vw"
            style={{ top: "auto", bottom: 0, paddingBottom: 0, maxWidth: "100vw" }}
        >
            {addDrinkContent}
        </Modal>
    );
};

export default AddDrink;
